import { Dialog } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";

const Container = styled.div`
  width: 100%;
  max-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  @supports (height: 100dvh) {
    min-height: 100dvh;
    max-height: 100dvh;
  }
`;

type FullscreenWrapperProps = {
  onClose: () => void;
  children: React.ReactNode;
  open: boolean;
};

export default function FullscreenWrapper(props: FullscreenWrapperProps) {
  const { onClose, children, open } = props;
  return (
    <Dialog fullScreen open={open} onClose={onClose} keepMounted>
      <Container>{children}</Container>
    </Dialog>
  );
}
